import { Box, TextField } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

import AvailableItemsPopper from './components/AvailableItemsPopper'
import { useListNewItem } from './hooks/useListNewItem'

import useStyles from './style'

const ListNewItem = ({ id, key }) => {
  const {
    searchPhrase,
    setSearchPhrase,
    onFocusInput,
    popupID,
    dropdownRef,
    anchorEl,
    canBeOpen,
    open,
    setOpen,
    addTempItem,
    deleteTemplate,
    isAvailableListFetching,
    list,
  } = useListNewItem({ id })
  const classes = useStyles()

  return (
    <Box className={classes.box} key={key}>
      <Box className={classes.box__inner}>
        <TextField
          fullWidth
          type="text"
          placeholder="Select keyword"
          value={searchPhrase}
          onFocus={(e) => {
            onFocusInput(e)
          }}
          onChange={(e) => {
            if (!open) onFocusInput(e)
            setSearchPhrase(e.target.value)
          }}
          onClick={(e) => {
            if (!open) {
              onFocusInput(e)
            }
          }}
        />
        <ClearIcon
          sx={{
            width: 20,
            height: 20,
            cursor: 'pointer',
          }}
          onClick={deleteTemplate}
        />
      </Box>
      <AvailableItemsPopper
        id={popupID}
        searchPhrase={searchPhrase}
        anchorEl={anchorEl}
        dropdownRef={dropdownRef}
        canBeOpen={canBeOpen}
        open={open}
        setOpen={setOpen}
        isAvailableListFetching={isAvailableListFetching}
        setSearchPhrase={setSearchPhrase}
        items={list}
        addNewItem={addTempItem}
      />
    </Box>
  )
}

export default ListNewItem
